import { Component, OnInit, Input } from '@angular/core';
import { Knowledge } from 'src/app/models/knowledge.model';
import { getLocalTranslate } from 'src/app/helpers/global-functions'

@Component({
  selector: 'app-knowledge-item',
  templateUrl: './knowledge-item.component.html',
  styleUrls: ['./knowledge-item.component.css']
})
export class KnowledgeItemComponent implements OnInit {

  @Input() knowledge:Knowledge = new Knowledge()

  readMore:string = 'Read More'

  constructor() { }

  ngOnInit(): void {
    this.needTranslate()
  }

  needTranslate(){
    this.readMore = getLocalTranslate('read-more',this.readMore)
  }

}
